import { ApiGetRequest } from './api-get-request';

export class PlayerRequest extends ApiGetRequest
{
    public constructor(webApiUrl: string)
    {
        super('player', null, null, webApiUrl);
    }
}
